/*
 * @Author: your name
 * @Date: 2020-12-18 18:47:42
 * @LastEditTime: 2021-01-20 11:27:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /za-dplatform-product-life/Users/zhongan/project/za-dplatform-main/za-dplatform-h5/src/components/_common/Value/index.js
 */
import React, { useEffect } from 'react';
import cn from 'classnames';
import { getStringValue } from '@U/tool';
import './index.less';
export default function Value(props) {
  const {
    value,
    placeholder,
    onClick,
    disabled,
    onChange
  } = props;
  const text = getStringValue(value);
  const cls = cn('cc-value', {
    'cc-value--placeholder': !text,
    'cc-value--disabled': disabled
  });
  useEffect(() => {
    onChange && onChange(value);
  }, [value]);

  const handleClick = () => {
    if (disabled) {
      return;
    }

    onClick();
  };

  return /*#__PURE__*/React.createElement("div", {
    onClick: handleClick,
    className: cls
  }, text || placeholder);
}